const UserState = {
    user: {},
    isLoggedIn: false
};

export default UserState;
